import { Select, SelectChangeEvent, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import { generateExerciceList } from 'routes/HumanResourcesModule/PayState/helpers/dataHelpers';
import { styled } from '@mui/material/styles';

type Props = {
    exercice: number;
};

const StyYearSelect = styled(Select, {
    name: 'StyYearSelect',
})(({ theme }) => ({
    '& .MuiSelect-select': {
        backgroundColor: theme.palette.primary.background,
        border: `1px solid ${theme.palette.primary.dark}`,
        color: theme.palette.primary.dark,
        fontSize: '12px',
        padding: '0.2rem 0.8rem',
        height: 'max-content',
        width: 'max-content',
        borderRadius: '20px',
        '&:focus': {
            borderRadius: '20px',
        },
    },
    '&:focus': {
        borderRadius: '20px',
    },
    '& .MuiOutlinedInput-notchedOutline': { border: 0, borderRadius: '20px' },
    '& svg.MuiSelect-icon': {
        color: theme.palette.primary.dark,
    },
    '& .MuiTypography-root': {
        fontSize: '0.9rem',
    },
}));

export default function PayStateExerciceSelector({ exercice }: Props) {
    const navigate = useNavigate();

    const options = generateExerciceList();
    const onChange = useCallback(
        (event: SelectChangeEvent<number>) => {
            const newExercice = event.target.value as number;
            navigate(`/human_resources/pay_state_home/${newExercice}`);
        },
        [navigate],
    );

    return (
        <StyYearSelect
            value={exercice}
            onChange={onChange}
            renderValue={(value: string) => <Typography>{value}</Typography>}
        >
            {options.map((option) => (
                <MenuItem key={option} value={option}>
                    {option}
                </MenuItem>
            ))}
        </StyYearSelect>
    );
}
